import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Google Analytics
declare global {
  interface Window {
    gtag?: (..._args: unknown[]) => void;
    dataLayer: unknown[];
  }
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
